export const MAX_ANSWER_LENGTH = 1024;

export const SCALE_MAP = {
  5: [1, 2, 3, 4, 5],
  3: [1, 3, 5],
  2: [1, 5],
};
